import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import MagicLogin from "../pages/Authentication/MagicLogin";
import Register from "../pages/Authentication/Register";
import VerifyEmailChange from "../pages/Authentication/VerifyEmailChange";

// User Profile
import UserProfile from "../pages/Authentication/UserProfile";
// BROKER DASHBOARD
import DashboardEmployerGroups from "../pages/DashboardBroker/DashboardEmployerGroups";
import DashboardEmployees from "../pages/DashboardBroker/DashboardBrokerEmployees";
// EMPLOYER DASHBOARD
import DashboardHome from "../pages/DashboardHome/DashboardUsers";
import DashboardGaBrokers from "../pages/DashboardGa/DashboardGaBrokers";
import DashboardGaEmployerGroups from "../pages/DashboardGa/DashboardGaEmployerGroups";
import DashboardGaEmployees from "../pages/DashboardGa/DashboardGaEmployees";

// Admin
import DashboardAdminGa from "../pages/DashboardAdmin/DashboardAdminGa";
import DashboardAdminBrokers from "../pages/DashboardAdmin/DashboardAdminBrokers";
import DashboardAdminEmployerGroups from "../pages/DashboardAdmin/DashboardAdminEmployerGroups";
import DashboardAdminEmployees from "../pages/DashboardAdmin/DashboardAdminEmployees";
import ProfileInfoRole from "../pages/ProfileInfoRole/ProfileInfoRole";
import { RoleBaseRoutes } from "./RoleBasedRoutes";
import DashboardIndividualBooks from "../pages/DashboardIndividualBooks/DashboardIndividualBooks";
import { DASHBOARD_USER_ROLES } from "../constants";
import DashboardNationalsEmployees from "../pages/DashboardNationals/DashboardNationalsEmployees";
import DashboardNationalsEmployerGroups from "../pages/DashboardNationals/DashboardNationalsEmployerGroups";
import DashboardNationalsBrokers from "../pages/DashboardNationals/DashboardNationalsBrokers";
import DashboardNationalsGa from "../pages/DashboardNationals/DashboardNationalsGa";
import DashboardAdminNational from "../pages/DashboardAdmin/DashboardAdminNational";
import PartnerIntegrations from "../pages/Admin/PartnerIntegrations/PartnerIntegrations";
import PartnerMembersPage from "../pages/Admin/PartnerIntegrations/PartnerMembersPage";
import BenefitSetsRollup from "../pages/BenefitSets/BenefitSetsRollup";
import ProfileEmployee from "../pages/ProfileInfoRole/Profiles/Employee/ProfileEmployee";
import AuthSteps from "../pages/Authentication/AuthSteps/AuthSteps";
import DashboardProfiles from "../pages/ProfileInfoRole/Profiles/DashboardProfiles";
import DashboardBilling from "../pages/DashboardBilling/DashboardBilling";
import InvoiceDetails from "../pages/DashboardBilling/InvoiceDetails";
import DashboardReports from "../pages/DashboardReports/DashboardReports";
import ReportDetails from "../pages/DashboardReports/ReportDetails";
import DashboardCommissions from "../pages/DashboardCommissions/DashboardCommissions";
import CommissionDetails from "../pages/DashboardCommissions/CommissionDetails";
import DashboardReferralCode from "../pages/ReferralCode/DashboardReferralCode";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// Admin Panel
import AppUsersDashboard from "../pages/Admin/AppUsers/AppUsersDashboard";
import AdminDashboard from "../pages/Admin/AdminDashboard/AdminDashboard";
import CommissionManagement from "../pages/Admin/CommissionManagement/CommissionManagement";
import ScheduleMonitoring from "../pages/Admin/ScheduleMonitoring/ScheduleMonitoring";
import PromoCodesManagement from "../pages/Admin/PromoCodesManagement/PromoCodesManagement";
import ServicesStatus from "../pages/Admin/ServicesStatus/ServicesStatus";
import ThemeCustomPlans from "../pages/Admin/ThemeCustomPlans/ThemeCustomPlans";
import DashboardResources from "../pages/Resources/DashboardResources";
import DrugSearch from "../pages/DrugSearch/DrugSearch";
import DashboardInviteUsers from "../pages/DashboardInviteUsers/DashboardInviteUsers";
import AgreementsStep from "../pages/Authentication/AuthSteps/Steps/AgreementsStep";
import DashboardPage from "../pages/DashboardPage/DashboardPage";
import AppUserInfoPage from "../pages/AppUserInfo/AppUserInfoPage";
import RouteWrapper from "../Components/RouteWrapper";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const authLandingRoutesInfo = [
  // Dashboard Page
  // { 
  //   path: "/enroll", 
  //   component: <DashboardPage />,
  //   title: "Enroll"
  // },
]

const authProtectedRoutesInfo = [
  {
    path: "/onboarding",
    component: <AuthSteps />,
    title: "Onboarding"
  },
  // Admin Routes
  {
    path: "dashboard-admin",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <AdminDashboard />
      </RoleBaseRoutes>
    ),
    title: "Admin Dashboard"
  },
  {
    path: "member-management",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <AppUsersDashboard />
      </RoleBaseRoutes>
    ),
    title: "Member Management"
  },
  {
    path: "commission-management",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <CommissionManagement />
      </RoleBaseRoutes>
    ),
    title: "Commission Management"
  },
  {
    path: "schedule-monitoring",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <ScheduleMonitoring />
      </RoleBaseRoutes>
    ),
    title: "Schedule Monitoring"
  },
  {
    path: "promo-codes",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <PromoCodesManagement />
      </RoleBaseRoutes>
    ),
    title: "Promo Codes"
  },
  {
    path: "services-status",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <ServicesStatus />
      </RoleBaseRoutes>
    ),
    title: "Services Status"
  },
  {
    path: "admin/themes/national/:nationalId/custom-plans",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <ThemeCustomPlans />
      </RoleBaseRoutes>
    ),
    title: "Custom Plans"
  },
  {
    path: "admin/national",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <DashboardAdminNational />
      </RoleBaseRoutes>
    ),
    title: "National Management"
  },
  {
    path: "admin/partner-integrations",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <PartnerIntegrations />
      </RoleBaseRoutes>
    ),
    title: "Partner Integrations"
  },
  {
    path: "admin/partner-integrations/:partnerId",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <PartnerMembersPage />
      </RoleBaseRoutes>
    ),
    title: "Partner Members"
  },
  {
    path: "admin/ga",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <DashboardAdminGa />
      </RoleBaseRoutes>
    ),
    title: "GA Management"
  },
  {
    path: "admin/brokers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <DashboardAdminBrokers />
      </RoleBaseRoutes>
    ),
    title: "Brokers Management"
  },
  {
    path: "/admin/employers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <DashboardAdminEmployerGroups />
      </RoleBaseRoutes>
    ),
    title: "Employers Management"
  },
  {
    path: "/admin/employees",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <DashboardAdminEmployees />
      </RoleBaseRoutes>
    ),
    title: "Employees Management"
  },
  {
    path: "/admin/member-management/:userId",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.ADMIN]}>
        <AppUserInfoPage />
      </RoleBaseRoutes>
    ),
    title: "User Details"
  },
  // Nationals Routes
  {
    path: "/national/ga",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.NATIONAL]}>
        <DashboardNationalsGa />
      </RoleBaseRoutes>
    ),
    title: "GA Dashboard"
  },
  {
    path: "/national/brokers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.NATIONAL]}>
        <DashboardNationalsBrokers />
      </RoleBaseRoutes>
    ),
    title: "Brokers Dashboard"
  },
  {
    path: "/national/employers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.NATIONAL]}>
        <DashboardNationalsEmployerGroups />
      </RoleBaseRoutes>
    ),
    title: "Employers Dashboard"
  },
  {
    path: "/national/employees",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.NATIONAL]}>
        <DashboardNationalsEmployees />
      </RoleBaseRoutes>
    ),
    title: "Employees Dashboard"
  },
  // GA routes
  {
    path: "/ga/brokers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.GA]}>
        <DashboardGaBrokers />
      </RoleBaseRoutes>
    ),
    title: "Brokers"
  },
  {
    path: "/ga/employers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.GA]}>
        <DashboardGaEmployerGroups />
      </RoleBaseRoutes>
    ),
    title: "Employers"
  },
  {
    path: "/ga/employees",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.GA]}>
        <DashboardGaEmployees />
      </RoleBaseRoutes>
    ),
    title: "Employees"
  },

  // Profile Info Role
  {
    path: "/:role/:id",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.ADMIN,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.EMPLOYER,
        ]}
      >
        <ProfileInfoRole />
      </RoleBaseRoutes>
    ),
    title: "Profile"
  },
  {
    path: "/:user/profile/:id",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.ADMIN,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.EMPLOYER,
        ]}
      >
        <DashboardProfiles />
      </RoleBaseRoutes>
    ),
    title: "User Profile"
  },

  // Broker Routes
  {
    path: "/broker/employees",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.BROKER]}>
        <DashboardEmployees />
      </RoleBaseRoutes>
    ),
    title: "Employees"
  },
  {
    path: "/broker/employers",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.BROKER]}>
        <DashboardEmployerGroups />
      </RoleBaseRoutes>
    ),
    title: "Employers"
  },
  // COMMISSIONS
  {
    path: "/commissions",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DashboardCommissions />
      </RoleBaseRoutes>
    ),
    title: "Commissions"
  },
  {
    path: "commissions/commissionDetail/:id",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <CommissionDetails />
      </RoleBaseRoutes>
    ),
    title: "Commission Details"
  },
  // INDIVIDUAL BOOKS OF BUSINESS
  {
    path: "/individuals",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DashboardIndividualBooks />
      </RoleBaseRoutes>
    ),
    title: "Individual Books"
  },
  // EMPLOYER ROUTES
  {
    path: "employees",
    component: (
      <RoleBaseRoutes allowedRoles={[DASHBOARD_USER_ROLES.EMPLOYER]}>
        <DashboardHome />
      </RoleBaseRoutes>
    ),
    title: "Employees"
  },
  {
    path: "billing",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DashboardBilling />
      </RoleBaseRoutes>
    ),
    title: "Billing"
  },
  {
    path: "billing/invoiceDetail/:id",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
        ]}
      >
        <InvoiceDetails />
      </RoleBaseRoutes>
    ),
    title: "Invoice Details"
  },
  {
    path: "reports",
    component: (
      <RoleBaseRoutes
        allowedRoles={[DASHBOARD_USER_ROLES.EMPLOYER]}
      >
        <DashboardReports />
      </RoleBaseRoutes>
    ),
    title: "Reports"
  },
  {
    path: "reports/:id",
    component: (
      <RoleBaseRoutes
        allowedRoles={[DASHBOARD_USER_ROLES.EMPLOYER]}
      >
        <ReportDetails />
      </RoleBaseRoutes>
    ),
    title: "Report Details"
  },
  {
    path: "employers/:employerId/invoices/current-month",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <InvoiceDetails />
      </RoleBaseRoutes>
    ),
    title: "Current Month Invoice"
  },

  // Invite Users
  {
    path: "invite-users",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DashboardInviteUsers />
      </RoleBaseRoutes>
    ),
    title: "Invite Users"
  },

  // User Profile
  {
    path: "/profile",
    component: <UserProfile />,
    title: "Profile"
  },
  // Benefit-set commission rollup for one employer (Avero partner integration).
  {
    path: "/benefit-sets/:parentExternalId",
    component: <BenefitSetsRollup />,
    title: "Benefit Sets"
  },
  // Drug Search Page
  {
    path: "/drug-search",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DrugSearch />
      </RoleBaseRoutes>
    ),
    title: "Drug Search"
  },
  // Resources Page
  {
    path: "/resources",
    component: (
      <RoleBaseRoutes
        allowedRoles={[
          DASHBOARD_USER_ROLES.BROKER,
          DASHBOARD_USER_ROLES.GA,
          DASHBOARD_USER_ROLES.NATIONAL,
          DASHBOARD_USER_ROLES.EMPLOYER,
          DASHBOARD_USER_ROLES.ADMIN,
        ]}
      >
        <DashboardResources />
      </RoleBaseRoutes>
    ),
    title: "Resources"
  },
  {
    path: "/profile",
    exact: true,
    component: <Navigate to="/profile" />,
    title: "Profile"
  },
  // Email verification (accessible for logged-in users)
  {
    path: "/verify-email-change",
    component: <VerifyEmailChange />,
    title: "Verify Email Change"
  },
  { path: "*", component: <Navigate to="/profile" /> },
];

const publicRoutesInfo = [
  // Authentication Page
  {
    path: "/referral/:code",
    component: <DashboardReferralCode />,
    title: "Referral"
  },
  {
    path: "/login",
    component: (
      <>
        {/* <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}> */}
        <Login />
        {/* </GoogleReCaptchaProvider> */}
      </>
    ),
    title: "Login"
  },
  {
    path: "/forgot-password",
    component: (
      <>
        {/* <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}> */}
        <ForgetPasswordPage />
        {/* </GoogleReCaptchaProvider> */}
      </>
    ),
    title: "Reset Password"
  },
  {
    path: "/register",
    component: (
      <>
        {/* <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}> */}
        <Register />
        {/* </GoogleReCaptchaProvider> */}
      </>
    ),
    title: "Register"
  },
  {
    path: "/verify-email-change",
    component: <VerifyEmailChange />,
    title: "Verify Email Change"
  },
  {
    // Consumes the Partner API magic link ({dashboard}/magic-login?token=...)
    path: "/magic-login",
    component: <MagicLogin />,
    title: "Signing in"
  },
  {
    path: "/",
    component: <Navigate to="/login" />
  },
  {
    path: "*",
    component: <Navigate to="/login" />
  },
];

// Process routes to wrap components with RouteWrapper
const processRoutes = (routes) => {


  return routes.map(route => ({
    ...route,
    component: route.title ? (
      <RouteWrapper title={route.title}>
        {route.component}
      </RouteWrapper>
    ) : route.component
  }));
};


// export default {
//   authProtectedRoutes: processRoutes(authProtectedRoutes),
//   publicRoutes: processRoutes(publicRoutes),
//   authLandingRoutes: processRoutes(authLandingRoutes),
// };

export const authProtectedRoutes = processRoutes(authProtectedRoutesInfo);
export const publicRoutes = processRoutes(publicRoutesInfo);
export const authLandingRoutes = processRoutes(authLandingRoutesInfo);